import React, {useState, useEffect} from 'react'
import { ShareContainer, RegistContainer, FormCotainer, RegistModalContent, CTitle, Center, Desc} from '@/styles/acitvityInfo'
import {  InputItem , Toast, Modal} from 'antd-mobile';
import h5Share from '@/utils/h5Share'
import {verifyPhone, sendMessage, register, getUser } from '@/api/user-new'
import Empty from '@/components/Empty'
import prizeHeader from '@/img/user-new/prize-header.png'
import closeModal from '@/img/user-new/close-modal.png'
import openApp from '@/img/user-new/open-app.png'
import lock from '@/img/user-new/lock.png'
import { rsaString } from '@/utils'

const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const SharePullRegist = ({props}) => {
  const [usename, setUsename] = useState('市值风云')
  const [value, setvalue] = useState('')
  const [code, setcode] = useState('')
  const [inviteCode, setinviteCode] = useState('')
  const [visible, setvisible] = useState(false)
  const [hasphone, setHasphone] = useState(false)
  const [type, setType] = useState('1')
  let [count, setCount] = useState(60)
  const getCode = () => {
    const val = value.replace(/\s*/g,"")
    if(!regPhone.test(val)){
      Toast.info('请输入正确手机号');
    } else {
      verifyPhone({C_PHONE: rsaString(val)}).then(res=> {
        if(res.resultCode === '00'){
          setType('1')
          setvisible(false)
          sendMessage({PHONE:rsaString(val), type: '0'}).then(res=>{
            if(res.resultCode === '00'){
              setHasphone(true)
              let timer = null
              clearInterval(timer)
              timer = setInterval(()=>{
                if(count === 0) {
                  clearInterval(timer)
                  setCount(60)
                  setHasphone(false)
                } else {
                  setCount(count--)
                }
              }, 1000)
            }
          })
        } else if(res.resultCode === '01') {
          setType('2')
          setvisible(true)
        } else if(res.resultCode === '01'){
          Toast.info('请输入正确手机号')
        }
      })
     
    }

  }
  const regist = () => {
    const val = value.replace(/\s*/g,"")
    if(regPhone.test(val)){
      const params ={
        phone: val, 
        smsCode: code,
        inviteCode: inviteCode
      }
      register(params).then(res=>{
        if(res.resultCode === '00'){
          setvisible(true)
          setType('1')
        } else {
          Toast.info(res.resultMsg);
        }
      })
    } else {
      Toast.info('请输入正确手机号')
    }
  }
  const openlink = () => {
    setvisible(false)
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }

  const changeValue = val => {
    setcode(val)
  }
  const onChangePhone = val =>{
    setvalue(val)
  }
  const initPage = () => {
    let data = {}
    setinviteCode(props.match.params.code)
    getUser({invitedCode: props.match.params.code}).then(res=>{
      if(res){
        setUsename(res)
         data = { 
          title:  `@${res}喊你一起来用市值风云APP了`, 
          desc: '注册制就看它！现在注册领价值554元付费研报大礼包', 
          link: window.location.href,
          imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
          wxShare:{
            shareData:{
              imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
            }
          }
        }
      h5Share.main(data)
      } else {
        setUsename('')
        data = {
          title: '一起来用市值风云APP了注册制就看它',
          desc: '注册制就看它！现在注册领价值554元付费研报大礼包',
          link: window.location.href,
          imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
          wxShare:{
            shareData:{
              imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
            }
          }
        }
        h5Share.main(data)
      }
   })
  }

  useEffect(() => {
    initPage()
    document.title = '春节邀请有礼，限时赢好礼'
    document.body.style = "background-color:#fbf1e4!important;"
  }, [])
 
  return (
    <ShareContainer>
      <RegistContainer Empty={usename}>
        <div className={'container'}>
        {usename?<div>
           <div className={'name-container'}>
            <span className={'name'}>@{usename}</span>
          </div>
          <div className={'info'}>喊你一起来用市值风云啦~注册制时代行情交易软件，3000家公司研报，独立吾股评级，注册制就看它！</div>
          <FormCotainer>
            <div className={'form-item'} > 
              <InputItem type="phone" defaultValue={value}   editable  clear onChange={(val)=>onChangePhone(val)}>+86</InputItem>
            </div> 
             <div className={'form-item'}>
              <InputItem type="number" className={'text'} defaultValue={code} editable  clear maxLength={4} placeholder={'请输入验证码'} onChange={(val)=>changeValue(val)}/>
              {!hasphone? <div className={'button active'} onClick={()=> getCode()}>获取验证码</div>: 
              <div className={'button'}>{count} 后重新获取 </div>}
            </div>
            <button className={'regist'} onClick={()=>regist()}>加入我们</button> 
          </FormCotainer>
          </div>:<Center><Empty text={'抱歉，邀请信息不正确，无法访问'} imageSrc={ require(`@/img/user-new//pic_zwdw2x.png`)}/></Center>}
        </div>
      </RegistContainer>
      <Desc>
        <img src="https://file.wogoo.com/image/activity/sharebg.png" className="desc-img" alt="" />
        <div className="title">现在注册即领价值554元付费研报</div>
        <img src={lock} className="lock" alt="" />
        <div className="desc-bottom">
          <div className="desc1">独家干货研报，久经时间检验<br></br>注册即可解锁</div>
          <div className="desc2">登录后点击【研究】-【研报】-【付费】频道查看</div>
        </div>
      </Desc>
      <Modal
          visible={visible}
          transparent
          className={'regist-modal'}
          maskClosable={true}
          onClose={()=> setvisible(false)}
          title=""
        >
          <RegistModalContent>
            <CTitle type={type}>
               <div className='back'>back</div>
               <div className='title'>{type==='1'? '恭喜': '提示'}</div>
               {type==='1' ? <img className="prize-header" src={prizeHeader} alt="" /> : ''}
            </CTitle>
           <div className={'regist-modal-content-text'}>{type==='1'? '您已经成功注册市值风云。快来与您的好友一起看行情、做交易、逛社区吧': <div>该手机号已注册过市值风云了<br/> 无需重复注册</div>}</div>
           <div className={'regist-modal-content-group'}>
            {type ==='2' &&<div className='regist-modal-button'><img className={'regist-modal-close'} src={closeModal} onClick={()=>setvisible(false)} alt=''/><img src={openApp} className={'regist-modal-close'} alt='' onClick={()=>openlink()}/></div>}
            {type ==='1' &&<div className={'regist-modal-content-button'} onClick={()=>openlink()}>打开APP</div>}
           </div>
          </RegistModalContent>
        </Modal>
    </ShareContainer>
  )
}

export default SharePullRegist


// WEBPACK FOOTER //
// ./src/views/user-new/share-pull-regist/index.js